/**
 * Validates a standard text field for required, minLength, and maxLength.
 *
 * @param {string} value - The field value to validate.
 * @param {string} fieldLabel - The human-readable field name for error messages.
 * @param {object} [options] - Validation options.
 * @param {boolean} [options.required=true] - Whether the field is required.
 * @param {number} [options.minLength=3] - Minimum character length (only checked if field is non-empty).
 * @param {number} [options.maxLength] - Maximum character length (only checked if field is non-empty).
 * @returns {string} An error message string, or an empty string if valid.
 */
export const validateTextField = (value, fieldLabel, { required = true, minLength = 3, maxLength } = {}) => {
  const trimmed = value?.trim() || '';

  if (!trimmed) {
    return required ? `${fieldLabel} is required` : '';
  }

  if (minLength && trimmed.length < minLength) {
    return `${fieldLabel} should atleast have ${minLength} characters`;
  }

  if (maxLength && trimmed.length > maxLength) {
    return `${fieldLabel} cannot exceed ${maxLength} characters`;
  }

  return '';
};
